/* Mejoras progresivas: los formularios GET siguen funcionando sin JavaScript. */
(() => {
  'use strict';
  document.addEventListener('click', async evento => {
    const boton = evento.target.closest('[data-hs-agregar]');
    if (!boton || boton.disabled) return;
    evento.preventDefault();
    const error = boton.closest('.hs-tarjeta')?.querySelector('.hs-tarjeta__error');
    boton.disabled = true;
    boton.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    try {
      await window.HS.carrito.agregar(Number(boton.dataset.hsAgregar), 1);
      window.HS.carrito.abrir();
    } catch (fallo) {
      if (error) {
        error.textContent = fallo.message || 'No se pudo añadir el producto. Inténtalo de nuevo.';
        error.hidden = false;
      }
    } finally {
      boton.disabled = false;
      boton.removeAttribute('aria-busy');
    }
  });

  const actualizarEstado = boton => {
    const agregado = boton.dataset.buttonStatus === 'added';
    const favorito = boton.classList.contains('js-wishlist');
    boton.setAttribute('aria-label', agregado ? (favorito ? 'Quitar de favoritos' : 'En comparación') : (favorito ? 'Agregar a favoritos' : 'Agregar a comparar'));
  };
  const selectorListas = '.hs-tarjeta__accion, [data-hs-listas] .js-wishlist, [data-hs-listas] .js-compare';
  document.querySelectorAll(selectorListas).forEach(actualizarEstado);
  new MutationObserver(cambios => cambios.forEach(cambio => {
    if (cambio.target.matches(selectorListas)) actualizarEstado(cambio.target);
  })).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['data-button-status'] });

  document.querySelectorAll('[data-hs-catalogo]').forEach(catalogo => {
    const panel = catalogo.querySelector('[data-hs-filtros-panel]');
    const fondo = catalogo.querySelector('[data-hs-filtros-fondo]');
    const abrir = catalogo.querySelector('[data-hs-filtros-abrir]');
    const cerrar = catalogo.querySelector('[data-hs-filtros-cerrar]');
    const movil = window.matchMedia('(max-width: 767px)');
    let abierto = false;
    let previos = [];
    catalogo.classList.add('hs-catalogo--js');
    const cerrarPanel = () => {
      if (!abierto) return;
      abierto = false;
      panel.classList.remove('hs-filtros--abierto');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      fondo.hidden = true;
      abrir.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('hs-filtros-abiertos');
      previos.forEach(([el, valor]) => { el.inert = valor; });
      previos = [];
      abrir.focus();
    };
    abrir.addEventListener('click', () => {
      if (abierto || !movil.matches) return;
      abierto = true;
      panel.classList.add('hs-filtros--abierto');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      fondo.hidden = false;
      abrir.setAttribute('aria-expanded', 'true');
      document.body.classList.add('hs-filtros-abiertos');
      // Aislar los hermanos de cada ancestro sin volver inert el propio diálogo.
      let rama = panel;
      while (rama.parentElement && rama !== document.body) {
        Array.from(rama.parentElement.children).forEach(el => {
          if (el !== rama && el !== fondo && el instanceof HTMLElement) {
            previos.push([el, el.inert]); el.inert = true;
          }
        });
        rama = rama.parentElement;
      }
      cerrar.focus();
    });
    cerrar.addEventListener('click', cerrarPanel);
    fondo.addEventListener('click', cerrarPanel);
    document.addEventListener('keydown', evento => {
      if (!abierto) return;
      if (evento.key === 'Escape') { evento.preventDefault(); cerrarPanel(); }
      if (evento.key === 'Tab') {
        const controles = Array.from(panel.querySelectorAll('a[href],button,input,select')).filter(el => !el.disabled && el.getClientRects().length);
        const primero = controles[0]; const ultimo = controles[controles.length - 1];
        if (evento.shiftKey && document.activeElement === primero) { evento.preventDefault(); ultimo.focus(); }
        else if (!evento.shiftKey && document.activeElement === ultimo) { evento.preventDefault(); primero.focus(); }
      }
    });
    movil.addEventListener('change', () => { if (!movil.matches) cerrarPanel(); });
    catalogo.querySelectorAll('[data-hs-filtros-form], [data-hs-orden-form]').forEach(form => {
      form.querySelector('[data-hs-orden-boton]')?.setAttribute('hidden', '');
      form.addEventListener('change', evento => {
        const esOrden = form.hasAttribute('data-hs-orden-form');
        if (!esOrden && (movil.matches || evento.target.type !== 'checkbox')) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });
  });
})();
